<template>
  <div class="wrapper">
    <skeleton-wrapper :is-loading="isLoading">
      <template v-slot:skeleton>
        <active-services-skeleton />
      </template>
      <template v-slot:content>
        <div class="row justify-content-center">
          <div
            class="col-12 col-md-10 mb-4"
            v-for="(service, index) in servicesHighlight"
            :key="index"
          >
            <highlighted-service-card
              :name="highlightName(service)"
              :description="service.description"
              :illustration="service.illustration ? service.illustration.url : ''"
              :route="service.route"
              :button-text="highlightButtonText(service)"
              :progress="service.progress"
              :preTitle="highlightPreTitle(service)"
              @ctaClicked="accessService(service.id, service.serviceType, service.serviceType)"
              :button-disabled="!canAccessServices"
            />
          </div>
        </div>
      </template>
    </skeleton-wrapper>
  </div>
</template>

<script>
import roleMixin from "../../mixins/roleMixin";
import HighlightedServiceCard from "../../molecules/cards/HighlightedServiceCard";
import SkeletonWrapper from "../SkeletonWrapper";
import ActiveServicesSkeleton from "../../molecules/skeletons/ActiveServicesSkeleton";

export default {
  name: "ActiveServices",
  mixins: [roleMixin],
  components: {
    HighlightedServiceCard,
    SkeletonWrapper,
    ActiveServicesSkeleton,
  },
  data() {
    return {
      isLoading: true,
      services: [],
      canAccessServices: false,
    };
  },
  mounted() {
    this.fetchActiveServices();
  },
  computed: {
    servicesHighlight() {
      return [...this.services.streams, ...this.services.programs];
    },
  },
  methods: {
    async fetchServices(progressState = 0) {
      return this.$axios
        .get(`/api/rest/home/activatedServices?progress=${progressState}`)
        .then((res) => {
          this.services = res.data.services;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
        });
    },
    async fetchActiveServices() {
      await this.fetchServices(0);
      await this.fetchServices(1);
      this.canAccessServices = true;
    },
    highlightName(service) {
      return service.serviceType === "stream" ? service.title : service.service;
    },
    highlightButtonText(service) {
      return this.isServiceCompleted(service)
        ? this.trans("home.finished")
        : this.getServiceAccessButtonLabel(service.serviceType);
    },
    highlightPreTitle(service) {
      return service.serviceType === "stream"
        ? this.trans("home.pre_blocktitle.stream")
        : this.trans("home.pre_blocktitle.program");
    },
    isServiceCompleted(service) {
      return service.progress && service.progress.percentage == 100;
    },
    getServiceAccessButtonLabel(serviceType) {
      return serviceType === "stream"
        ? this.trans("home.access.stream")
        : this.trans("home.access.program");
    },
  },
};
</script>

<style scoped>
.wrapper {
  min-height: 250px;
}
</style>
